import { ImageCell } from '@/components/shared/ImageCell';
import type { Hotel } from '@/config/objects/hotels';

interface HotelImageCellProps {
  hotel?: Hotel;
  size?: 'sm' | 'lg';
}

/**
 * Editable hotel image cell component with upload and delete actions
 */
export function HotelImageCell({ hotel, size = 'sm' }: HotelImageCellProps) {
  return (
    <ImageCell
      item={hotel}
      endpoint="/hotels"
      entityName="Hotel"
      imageLabel="Hotel Image"
      getFeaturedImage={(item) => item.featuredImage}
      getItemId={(item) => item.id}
      size={size}
    />
  );
}
